import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import { Locations, Product, NavigationEvents } from '@mc/track-event'
import Link from 'components/Link'
import { trackNavigationClick } from '../events'

export const AtWorkLink = ({
  className = '',
  location = Locations.NAVIGATION,
  product = Product.AT_WORK,
}: {
  className?: string
  location?: (typeof Locations)[keyof typeof Locations]
  product?: (typeof Product)[keyof typeof Product]
}) => {
  const { t } = useTranslation('@mc/next')

  const ctaCopy = t('nav.cta.work')

  const handleAtWorkClick = () => {
    trackNavigationClick(
      ctaCopy,
      NavigationEvents.LEVELS.PRIMARY,
      location,
      product,
    )
  }

  return (
    <Link
      href={paths.enterpriseHomepage}
      className={`mc-ml-4 ${className}`}
      onClick={handleAtWorkClick}
      passHref
      newTab
    >
      {ctaCopy}
    </Link>
  )
}
